<template>
  <!-- v-infinite-scroll="layoutWrapLoad" :infinite-scroll-disabled="infiniteScrollDisabled" -->
  <div class="wrap" id="layoutWrap">
    <div id="scrollTopId"></div>
    <Header></Header>
    <div class="menu" :style="{display: showBackMenu ? 'none' : 'flex'}">
      <div class="menu_con">
        <el-button @click="$router.go(-1)" plain
          style='border:0;padding: 0;margin-left: 20px;'>
          <i class="el-icon-arrow-left"></i>
          返回
        </el-button>
        <!-- <el-button class="menu_item " :class="{menu_active: $route.path === '/home'}" plain style='border:0;padding: 0;'>
          首页
          <i class="el-icon-error el-icon--right"></i>
        </el-button>
        <el-button class="menu_item " :class="{menu_active: $route.path === '/home'}" plain style='border:0;padding: 0;'>
          个人中心
          <i class="el-icon-error"></i>
        </el-button> -->
      </div>
    </div>
    <div class="main-box">
      <div class="main">
        <div class="main-con">
          <keep-alive>
            <router-view v-if="$route.meta && $route.meta.keepAlive">
            </router-view>
          </keep-alive>
          <router-view v-if="!($route.meta && $route.meta.keepAlive)">
          </router-view>
        </div>
      </div>
    </div>
    <!-- to top -->
    <el-backtop target="#layoutWrap"></el-backtop>
    <!-- <el-button class="goto_top" @click="gotoTop"><i
        class="el-icon-caret-top"></i></el-button> -->
  </div>
</template>
<script>
import vueBus from '@/common/vueBus.js';
import Header from '../header';
import { checkLoginApi } from '@/views/apis';
export default {
  components: { Header },
  data () {
    return {
    };
  },
  computed: {
    // 是否禁用滚动
    infiniteScrollDisabled () {
      return this.$store.state.infiniteScrollDisabled;
    },
    showBackMenu () {
      // 不需要返回按钮的页面
      let pathIgnore = ['/home', '/blog-detail', '/authors'];
      return pathIgnore.includes(this.$route.path);
    },
    userId () {
      return (localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}).id;
    }
  },
  created () {
    this.checkLoginRequest(); // 初次进入页面验证一次用户登录状态，过期自动跳到登录页
    this.checkoutLogin(); // 半小时定时验证一次用户登录状态，过期自动跳到登录页
  },
  mounted () {
    document.getElementById('layoutWrap').addEventListener('scroll', this.pageScroll, false); // 监听（绑定）滚轮滚动事件
  },
  beforeDestroy () {
    // document.getElementById('layoutWrap').removeEventListener('scroll', this.pageScroll); //  离开页面清除（移除）滚轮滚动事件
  },
  methods: {
    // 滚动加载分页
    pageScroll () {
      var that = this;
      let dom = document.getElementById('layoutWrap');
      // 滚动条滚动时，距离顶部的距离
      var scrollTop = dom.scrollTop;
      // 可视区的高度
      var windowHeight = dom.clientHeight;
      // 滚动条的总高度
      var scrollHeight = dom.scrollHeight;
      // console.log('滚动条滚动时，距离顶部的距离', scrollTop, '可视区的高度', windowHeight, '滚动条的总高度', scrollHeight);
      // 滚动条到底部的条件
      if (scrollTop + windowHeight >= scrollHeight - 10 && !that.infiniteScrollDisabled) {
        console.log('滚动条到底部');
        // 加载数据
        vueBus.$emit('layoutWrapLoad', '触底');
      }
    },
    gotoTop () {
      document.getElementById('scrollTopId').scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    },
    checkoutLogin () {
      setTimeout(() => {
        this.checkLoginRequest();
        this.checkoutLogin();
      }, 1800000); // 半小时验证一次
    },
    checkLoginRequest () {
      if (!this.userId) { return; };
      checkLoginApi({ userId: this.userId }).then(res => {
        if (res.errno === 0) {
          console.log(res.message);
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.wrap {
  position: relative;
  background: #f4f5f5;
  height: 100%;
  box-sizing: border-box;
  padding-bottom: 30px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  .menu {
    position: sticky;
    top: 61px;
    left: 0;
    flex-shrink: 0;
    z-index: 99;
    background: #ffffff;
    width: 100%;
    height: 46px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #f1f1f1;
    .menu_con {
      width: 960px;
      display: flex;
      .menu_item {
        color: #71777c;
        font-size: 14px;
        margin-left: 10px;
        // cursor: pointer;
        .el-icon-error {
          opacity: 0;
        }
        &:hover .el-icon-error {
          opacity: 1;
          color: #f7958d;
        }
      }
      .menu_active {
        color: #007fff;
      }
    }
  }
  .main-box {
    width: 100%;
    display: flex;
    justify-content: center;
    .main {
      width: 960px;
      // border-top: 1px solid #F1F1F1;
      .main-con {
        width: 700px;
        padding: 15px 0;
      }
    }
  }
  .goto_top {
    width: 40px;
    height: 40px;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 150px;
    right: 50px;
    border-radius: 50%;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
    font-size: 20px;
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 980px) {
  .wrap {
    // position: relative;
    // background: #f4f5f5;
    // height: 100%;
    // box-sizing: border-box;
    // padding-bottom: 30px;
    // overflow: auto;
    // display: flex;
    // flex-direction: column;
    .menu {
      // position: sticky;
      top: 51px;
      // left: 0;
      // flex-shrink: 0;
      // z-index: 99;
      // background: #ffffff;
      // width: 100%;
      height: 36px;
      // display: flex;
      // justify-content: center;
      // align-items: center;
      // border-bottom: 1px solid #f1f1f1;
      .menu_con {
        width: 100%;
        // display: flex;
        // .menu_item {
        //   color: #71777c;
        //   font-size: 14px;
        //   margin-left: 10px;
        //   .el-icon-error {
        //     opacity: 0;
        //   }
        //   &:hover .el-icon-error {
        //     opacity: 1;
        //     color: #f7958d;
        //   }
        // }
        // .menu_active {
        //   color: #007fff;
        // }
      }
    }
    .main-box {
      // width: 100%;
      // display: flex;
      // justify-content: center;
      .main {
        width: 100%;
        .main-con {
          width: 100%;
          // padding: 15px 0;
        }
      }
    }
    .goto_top {
      // width: 40px;
      // height: 40px;
      // background: #ffffff;
      // display: flex;
      // justify-content: center;
      // align-items: center;
      // position: fixed;
      bottom: 50px;
      right: 20px;
      // border-radius: 50%;
      // box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
      // font-size: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/index.vue